import React, { useEffect, useState } from 'react';
import ProjectItem from './ProjectItem';
import { ProjectList } from './ProjectList';
import './ProjectItem.scss'
import Animated from '../AnimatedLetters/Animated';



const ProjectSection = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <div className="container p-sec">
      <h1>
        <Animated
          letterClass={letterClass}
          strArray={['M', 'y', ' ', 'P', 'r', 'o', 'j', 'e', 'c', 't', 's']}
          idx={15}
        />
      </h1>
      <div className="row row-cols-1 row-cols-md-3 g-4 mt-3">
        {ProjectList.map((project, idx) => {
          return (
            <ProjectItem id={idx} name={project.name} image1={project.image1} image2={project.image2} image3={project.image3} />
          );
        })}
      </div>
    </div>
  );
};

export default ProjectSection;